import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme, VStack } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import type { Credit } from '../../graphql/types';

export const CreditBalanceDetails = ({
  creditDetails,
}: CreditBalanceDetailsProps) => {
  const { t, formatPrice, formatDate } = useLocalizationContext();

  return (
    <VStack style={styles.availableCreditList} divider>
      {creditDetails.map((detail) => (
        <View key={detail.id} style={styles.creditViewItem}>
          <View>
            <BodyText size={4} bold>
              {formatDate(detail.createdAt)}
            </BodyText>
            <BodyText size={4}>{detail.title}</BodyText>
            {detail.expiresAt ? (
              <BodyText size={5} style={styles.expiresAt}>
                {t('account.credit.expires', {
                  date: formatDate(detail.expiresAt),
                })}
              </BodyText>
            ) : null}
          </View>
          <View>
            <BodyText size={4} bold>
              {formatPrice(detail.remainingAmount, 'USD')}
            </BodyText>
          </View>
        </View>
      ))}
    </VStack>
  );
};

type CreditBalanceDetailsProps = {
  readonly creditDetails: readonly Credit[];
};

const styles = StyleSheet.create({
  availableCreditList: {
    paddingVertical: theme.spacing['6'],
    width: '100%',
  },
  creditViewItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  expiresAt: {
    paddingTop: theme.spacing['1'],
    color: theme.colors.NEUTRAL_2,
  },
});
